<template>
  <div v-if="isVisible(field)" class="ApplicationFieldGroup" :id="field.elemId">
    <div
      v-if="isVisible(groupField)"
      class="groupField"
      :class="groupField.className"
      v-for="(groupField, index) in field.fields()"
      :key="groupField.apiKey + index"
    >
      <ApplicationField :section="section" :field="groupField" />
    </div>
  </div>
</template>

<script>
import ApplicationField from '@/components/application/ApplicationField.vue'

export default {
  name: 'ApplicationFieldGroup',
  components: {
    ApplicationField
  },
  props: ['section', 'field'],
  computed: {
    application() {
      return this.$store.state.application
    }
  },
  methods: {
    isVisible(field) {
      return field.visible ? field.visible(this.application) : true
    }
  }
}
</script>

<style lang="scss">
.ApplicationFieldGroup {
  margin-right: 1rem;
  margin-bottom: 3.5rem;
  margin-left: 1rem;
  padding: 2rem 2rem 0;
  background-color: $color-white;

  .groupField.fieldInline {
    display: inline-block;
    width: auto;
  }
}
</style>
